import React, { Component } from "react";
import Slider from "react-slick";
import BannerImg1 from "../assets/images/banner/banner-home1.png";

const MainSlider = ({ banners }) => {
  const settings = {
    arrows: false,
    dots: false,
    swipeToSlide: true,
    infinite: true,
    autoplay: true,

    slidesToShow: 2,
    slidesToScroll: 1,

    speed: 3000,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className="">
      <Slider {...settings}>
        {banners &&
          banners.length &&
          banners.map((b, index) => {
            const firstCta = b?.ctabtns.length > 0 ? b?.ctabtns?.[0] : null;
            return (
              <div
                className={`mainBannerDiv ${
                  firstCta?.actionLink ? "has-link" : ""
                }`}
                key={index}
                onClick={() => {
                  if (firstCta?.actionLink) {
                    window.location.href = firstCta.actionLink;
                  }
                }}
              >
                <img src={b.link} alt="First Slide" />
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default MainSlider;
